const accessAuth = {

    LOGIN: {
        path: '/login'
    },
    ROLE_LOGIN: {
        path: '/role-login'
    },

    UNKNOWN_PATH: {
        path: '*'
    }

}

export default accessAuth;